/**
 * @spec docs/specs/features/staking-position-ui.md
 * Root application component with providers and routing
 */
import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { PrivyProvider } from '@privy-io/react-auth';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { PRIVY_APP_ID, privyConfig } from '@/lib/privy';
import { AppRoutes } from '@/lib/router';
import { queryClient } from '@/lib/query-client';
import { markStaleFailed } from '@/lib/transaction-history';
import { WalletProvider } from '@/contexts/WalletContext';
import { ErrorBoundary } from '@/components/ErrorBoundary';

function App() {
  useEffect(() => {
    markStaleFailed();
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <PrivyProvider appId={PRIVY_APP_ID} config={privyConfig}>
          <WalletProvider>
            <BrowserRouter>
              <div className="min-h-screen bg-bg-primary bg-radial-purple-top-left text-text-primary">
                <AppRoutes />
              </div>
              <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                  style: {
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-primary)',
                  },
                  classNames: {
                    success: 'border-l-4 !border-l-[var(--status-success)]',
                    error: 'border-l-4 !border-l-[var(--status-error)]',
                    warning: 'border-l-4 !border-l-[var(--status-warning)]',
                    info: 'border-l-4 !border-l-[var(--status-info)]',
                  },
                }}
              />
            </BrowserRouter>
          </WalletProvider>
        </PrivyProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
